import classNames from 'classnames'
import React from 'react'
import { ImageUploadButton } from '../button/imageUploadButton'
import Icon from '../icon'
import { ErrorText } from '../typography/ErrorText'

export const ImageBanner = ({
  loading,
  imageUrl,
  className = '',
  errors,
  onDelete,
  onImageEdit,
  editIconPos = 'bottom-right',
  initials,
}: {
  loading?: boolean
  imageUrl: string
  className?: string
  errors?: string
  onDelete?: () => void
  onImageEdit?: (e: React.ChangeEvent<HTMLInputElement>) => void
  editIconPos?: 'bottom-right' | 'top-right'
  initials?: string
}) => {
  return (
    <div
      style={{
        backgroundImage: imageUrl
          ? `url('${imageUrl}')`
          : className.includes('rounded-full')
            ? undefined
            : `url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='8' ry='8' stroke='%237A7978FF' stroke-width='2' stroke-dasharray='6%2c 8' stroke-dashoffset='0' stroke-linecap='square'/%3e%3c/svg%3e")`,
      }}
      className={classNames(
        `
        h-[120px] md:h-[240px] lg:h-[280px] bg-cover
        w-full
        rounded-md
        flex flex-col items-center justify-center
        text-lg text-black font-medium
        relative bg-white
        ${loading && 'animate-pulse !bg-gray-300'}
        relative bg-no-repeat
        bg-cover
        ${imageUrl ? 'shadow-lg' : 'shadow-none'}
        ${className.includes('rounded-full') && !imageUrl ? 'border' : ''}
        ${className}
    `,
        {
          '!bg-black !text-white': initials && !imageUrl,
        },
      )}
    >
      {errors && (
        <span className="">
          <ErrorText text={errors} />
        </span>
      )}

      {!imageUrl && !initials && (
        <Icon id="pic-icon" width={24} height={24} className="text-sec-black" />
      )}

      {initials && !imageUrl && <p>{initials}</p>}

      {onDelete && (
        <button
          type="button"
          className="absolute w-[24px] !h-[24px] flex items-center justify-center bg-danger rounded-full top-2 right-2"
          onClick={onDelete}
        >
          <Icon className="text-white" width={14} height={14} id="bin" />
        </button>
      )}

      {onImageEdit && (
        <ImageUploadButton
          handleChange={onImageEdit}
          showText={false}
          icon={'edit'}
          iconDim={14}
          className={classNames(
            `
          !bg-off-white
          !absolute !w-[24px] !h-[24px] !m-0 
          !rounded-full !p-0
          !col-span-full !text-black
          `,
            {
              '!top-auto !bottom-0 !right-2': editIconPos === 'bottom-right',
              '!top-2 !bottom-auto !right-2': editIconPos === 'top-right',
            },
          )}
          dottedBorder={false}
        />
      )}
    </div>
  )
}
